const $ = require('jquery')
const Vue = require('vue')

Vue.directive('portlet-expand', {
    twoWay: false,
    priority: 1000,

    params: [],

    bind: function () {
        const $el = $(this.el)

        $el
            .removeClass('portlet-expand')
            .addClass('portlet-expand')

        // $el.unbind('click').click(function (evt) {
        //     evt.preventDefault()
        //
        //     const $body = $(this)
        //         .closest('.portlet')
        //         .children('.portlet-body')
        //
        //     if ($(this).hasClass('portlet-collapsed')) {
        //         $(this).removeClass('portlet-collapsed')
        //         $body.slideDown(200)
        //     } else {
        //         $(this).addClass('portlet-collapsed')
        //         $body.slideUp(200)
        //     }
        // })
    },
    update: function (value) {
        const $el = $(this.el)

        const $body = $el
            .closest('.portlet')
            .children('.portlet-body')

        if (value) {
            $el.removeClass('portlet-collapsed')
            $body.show()
        } else {
            $el.addClass('portlet-collapsed')
            $body.hide()
        }
    },
    unbind: function () {
        // $(this.el).off().select2('destroy')
    }
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/portlet-expand.js